import React, { useState, useEffect } from 'react';
import { forAuthorsService } from '../services/api';

function parseJson(value, fallback) {
  if (!value) return fallback;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

function AuthorGuide() {
  const [steps, setSteps] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await forAuthorsService.get();
        if (response.data) {
          setSteps(parseJson(response.data.steps, []));
          setRequirements(parseJson(response.data.requirements, []));
          setNotes(response.data.notes || '');
        }
      } catch (error) {
        console.error('Error fetching for authors content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">راهنمای نویسندگان</h1>
          <p className="text-xl text-blue-100">نحوه آماده‌سازی و ارسال مقاله</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Steps */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">مراحل ارسال مقاله</h2>
          {steps.length === 0 ? (
            <div className="text-center text-gray-500">محتوایی ثبت نشده</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {steps.map((step, idx) => (
                <div key={idx} className="bg-white rounded-xl shadow-md p-8">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 text-2xl">
                      {step.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-900">{step.title}</h3>
                    </div>
                  </div>
                  <p className="text-gray-700">{step.description}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Requirements */}
        <section className="bg-white rounded-xl shadow-md p-8 mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">الزامات مقاله</h2>
          {requirements.length === 0 ? (
            <div className="text-center text-gray-500">محتوایی ثبت نشده</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {requirements.map((req, idx) => (
                <div key={idx} className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                  <div className="text-2xl flex-shrink-0">{req.icon}</div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-2">{req.title}</h3>
                    <p className="text-gray-700">{req.description}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* Tips */}
        <section className="bg-blue-50 rounded-xl border-r-4 border-blue-700 p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">نکات مهم</h2>
          {notes ? (
            <p className="text-gray-700 whitespace-pre-wrap">{notes}</p>
          ) : (
            <div className="text-center text-gray-500">محتوایی ثبت نشده</div>
          )}
        </section>
      </div>
    </div>
  );
}

export default AuthorGuide;
